export const BillingCountryLabel: Partial<Record<AvailableCountries, string>> = {
  AU: 'Australia (AUD)',
  NZ: 'New Zealand (NZD)',
  SG: 'Singapore (SGD)',
  ID: 'Indonesia (USD)',
  HK: 'Hong Kong (USD)',
  JP: 'Japan (USD)',
  MY: 'Malaysia (USD)',
  PH: 'Philippines (USD)',
  US: 'United States (USD)',
  CA: 'Canada (USD)',
  TH: 'Thailand (USD)',
  VN: 'Vietnam (USD)',
  KR: 'South Korea (USD)',
};
